window.switchLang = function(url) {
    //console.log("Switching language to:", url); // Existing log

    $.ajax({
        type: 'GET',
        url: url,
        success: function (response) {
            // console.log("Language switch successful!"); // Existing log
            // console.log("Received previous URL:", response); // Log the received previous URL

            if (response.previousUrl) {
                location.href = response.previousUrl;
            } else {
                // Handle case where no previous URL is available (e.g., reload)
                location.reload();
            }
        },
        error: function (response) {
            console.error("Error switching language:", response); // Existing log
            reloadPageAfterSwitchingLanguage(); // Consider removing this if unnecessary
        }
    });
}

window.reloadPageAfterSwitchingLanguage = function() {
    //console.log("Reloading page after language switch");

    let previousUrl = response.previousUrl; // Access from AJAX response
    if (previousUrl) {
        location.href = previousUrl;
    } else {
        // Handle case where no previous URL is available (e.g., reload)
        location.reload();
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/language_switcher.js